import { Link } from "react-router-dom";
import ethitechImage from "../assets/images/projectimages/ethitech.png";
import greenevilleDeliImage from "../assets/images/projectimages/greeneville-deli.png";
import worldAppImage from "../assets/images/projectimages/world-app.png";
import medicalImage from "../assets/images/projectimages/gallaghermedical.png";

const imageMap = {
    "ethitech.png": ethitechImage,
    "greeneville-deli.png": greenevilleDeliImage,
    "world-app.png": worldAppImage,
    "gallaghermedical.png": medicalImage
};

const ProjectCard = ({ project }) => {
    if (!project) {
        return <p>Project not found</p>;
    }

    const imageUrl = imageMap[project.images[0].url];

    return (
        <div className="group block overflow-hidden rounded-lg  custom-hover-bg">
            <Link to={`/projects/${project.slug}`} className="relative">
                <img className="object-cover w-full h-48 sm:h-64 md:h-72 lg:h-80" src={imageUrl} alt={project.images[0].caption} />
            </Link>
            <div className="p-4">
            <Link to={`/projects/${project.slug}`} className="relative">
            <h1 className=" text-2xl font-bold">{project.title}</h1>
            </Link>
                <p className="font-bold">{project.description}</p>
                <div className="flex flex-wrap mt-2">
                    {project.technologies.map((tech, index) => (
                        <span key={index} className="bg-gray-600 text-gray-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">
                            {tech}
                        </span>
                    ))}
                </div>
                <div className="mt-4 flex space-x-4">
                    <a href={project.links[0].url} target="_blank" rel="noopener noreferrer" className="bg-orange-600 px-4 py-2 rounded-md hover:bg-orange-500">
                        Live Version
                    </a>
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="bg-gray-800 px-4 py-2 rounded-md hover:bg-gray-700">
                        GitHub
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;